import { useEffect } from 'react';
import type { UseCameraResult } from '../hooks/useCamera';

interface CameraViewProps {
  camera: UseCameraResult;
}

export function CameraView({ camera }: CameraViewProps) {
  const { videoRef, error, active, start, stop } = camera;

  useEffect(() => {
    start();
    return () => stop();
  }, [start, stop]);

  return (
    <div className={`camera-area ${active ? 'camera-active' : ''}`}>
      <video
        ref={videoRef as React.RefObject<HTMLVideoElement>}
        playsInline
        muted
        style={{ display: active ? 'block' : 'none' }}
        aria-hidden={!active}
      />
      {!active && (
        <div className="placeholder-inner">
          <span className="icon" aria-hidden>🐾</span>
          <span>
            {error ? (
              <>
                <strong>{error}</strong>
                {error.includes('安全连接') ? null : (
                  <>
                    <br />
                    可在设置中允许相机权限后刷新
                  </>
                )}
              </>
            ) : (
              <>
                <strong>把镜头对准毛孩子</strong>
                <br />
                正在打开相机…
              </>
            )}
          </span>
        </div>
      )}
    </div>
  );
}
